import { FC } from 'react';
import { Grid } from '@mui/material';
import { useDashboard } from '../../../../../contexts';
import { useAccountStatisticsData } from '../../../../../hooks';
import { PnlCard, WinLossRateCard } from '../';

export const CardsSection: FC = () => {
  const { account } = useDashboard();

  const { data: accountStats } = useAccountStatisticsData(
    account?.tsAccountId || '',
    account || undefined,
  );

  if (!account) {
    return null;
  }

  if (!accountStats) {
    return null;
  }

  return (
    <Grid
      size={{ xs: 12, md: 6 }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: { sm: '100%' },
      }}
    >
      <Grid
        container
        spacing={8}
        sx={{
          flex: 1,
          height: '100%',
          alignContent: 'stretch',
        }}
      >
        <Grid size={{ xs: 12, sm: 6 }} sx={{ display: 'flex' }}>
          <PnlCard />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ display: 'flex' }}>
          <WinLossRateCard winRate={accountStats.winRate || 0} />
        </Grid>
      </Grid>
    </Grid>
  );
};
